var pegRewardsResponse = {
  "loyalty": [{
    "id": 8757,
    "alertEnabled": false,
    "cost": "1.0",
    "createdAt": "2023-02-16T16:13:15-08:00",
    "description": "This is a mock reward for dev teams to test UI showing multiple rewards",
    "displayName": "",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/61fb0d897011f1bc2ee309e6595b10a0.png",
    "instructions": "Can be redeemed at checkout online or in store",
    "name": "10 Peg Reward",
    "points": 10,
    "posCode": "",
    "posInstructions": "",
    "rewardType": "base",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-02-27T12:15:09-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/61fb0d897011f1bc2ee309e6595b10a0.png"
    }],
    "couponCode": null
  }, {
    "id": 8744,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-09T11:58:21-08:00",
    "description": "Birthday Reward",
    "displayName": "Birthday Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/76bae53fcfdb1581da291282fc364241.png",
    "instructions": "Birthday Reward",
    "name": "Birthday Reward",
    "points": 10,
    "posCode": "",
    "posInstructions": "",
    "rewardType": "birthday",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:03:44-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/76bae53fcfdb1581da291282fc364241.png"
    }],
    "couponCode": null
  }, {
    "id": 8751,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-09T13:03:55-08:00",
    "description": "Anniversary Reward",
    "displayName": "Anniversary Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/1bc3cbc52464beb26854ac6a36c87cee.png",
    "instructions": "Anniversary Reward",
    "name": "Anniversary Reward",
    "points": 10,
    "posCode": "",
    "posInstructions": "Anniversary Reward",
    "rewardType": "member_anniversary",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:02:38-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/1bc3cbc52464beb26854ac6a36c87cee.png"
    }],
    "couponCode": null
  }, {
    "id": 8725,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-01-26T10:46:45-08:00",
    "description": "Welcome Reward",
    "displayName": "Welcome Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/32570b2d438d4a4f41f5d9f23c6f3fb2.png",
    "instructions": "Welcome Reward",
    "name": "Welcome Reward",
    "points": 10,
    "posCode": "",
    "posInstructions": "Welcome Reward",
    "rewardType": "base",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:02:38-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/32570b2d438d4a4f41f5d9f23c6f3fb2.png"
    }],
    "couponCode": null
  }, {
    "id": 8749,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-09T12:17:33-08:00",
    "description": "75 Peg Reward",
    "displayName": "75 Peg Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/e8c3ddc5f56f4ef7a4d955e222cf99c4.png",
    "instructions": "75 Peg Reward",
    "name": "75 Peg Reward",
    "points": 75,
    "posCode": "",
    "posInstructions": "75 Peg Reward",
    "rewardType": "base",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:02:38-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/e8c3ddc5f56f4ef7a4d955e222cf99c4.png"
    }],
    "couponCode": null
  }, {
    "id": 8745,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-09T12:10:37-08:00",
    "description": "150 Peg Reward",
    "displayName": "150 Peg Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/78861e569271f4282225917e4ae747f9.png",
    "instructions": "150 Peg Reward",
    "name": "150 Peg Reward",
    "points": 150,
    "posCode": "",
    "posInstructions": "150 Peg Reward",
    "rewardType": "base",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:02:38-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/78861e569271f4282225917e4ae747f9.png"
    }],
    "couponCode": null
  }, {
    "id": 8746,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-09T12:12:15-08:00",
    "description": "225 Peg Reward",
    "displayName": "225 Peg Reward",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/58d4cd7621811f12c5941362f8e357e1.png",
    "instructions": "225 Peg Reward",
    "name": "225 Peg Reward",
    "points": 10,
    "posCode": "",
    "posInstructions": "225 Peg Reward",
    "rewardType": "base",
    "status": true,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T09:02:38-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": false
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/58d4cd7621811f12c5941362f8e357e1.png"
    }],
    "couponCode": null
  }, {
    "id": 8765,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-27T12:12:04-08:00",
    "description": "Feed America Donation $5",
    "displayName": "Feed America Donation $5 ",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/c512b4c1d82ff66ed9ec6cf4bb978fe1.png",
    "instructions": "Feed America Donation $5",
    "name": "Feed America Donation $5 ",
    "points": 75,
    "posCode": "",
    "posInstructions": "Feed America Donation $5",
    "rewardType": "base",
    "status": false,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T07:15:46-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": true
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/c512b4c1d82ff66ed9ec6cf4bb978fe1.png"
    }],
    "couponCode": null
  }, {
    "id": 8766,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-27T12:13:49-08:00",
    "description": "Feed America Donation $10",
    "displayName": "Feed America Donation $10",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/6177acb773ab454f9691d3952f9e0bdd.png",
    "instructions": "Feed America Donation $10",
    "name": "Feed America Donation $10",
    "points": 10,
    "posCode": "",
    "posInstructions": "Feed America Donation $10",
    "rewardType": "base",
    "status": false,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T07:15:24-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": true
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/6177acb773ab454f9691d3952f9e0bdd.png"
    }],
    "couponCode": null
  }, {
    "id": 8767,
    "alertEnabled": false,
    "cost": "0.0",
    "createdAt": "2023-02-27T12:14:56-08:00",
    "description": "Feed America Donation $15",
    "displayName": "Feed America Donation $15",
    "expirationDate": null,
    "externalId": "",
    "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/437ed519e1b14ceb19fa0929b486067a.png",
    "instructions": "Feed America Donation $15",
    "name": "Feed America Donation $15",
    "points": 10,
    "posCode": "",
    "posInstructions": "Feed America Donation $15",
    "rewardType": "base",
    "status": false,
    "threshold": 0,
    "tiersRequired": false,
    "updatedAt": "2023-03-01T07:15:35-08:00",
    "tiers": [],
    "viewOptions": {
      "iframeHidden": true
    },
    "media": [{
      "default": true,
      "displayName": "Default",
      "key": "default",
      "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/437ed519e1b14ceb19fa0929b486067a.png"
    }],
    "couponCode": null
  }]
};
var bonusRewardsResponse = {
  "loyalty": {
    "customers": {
      "email": "santiago.arellano@verndale.com",
      "createdAt": "2023-03-20T13:41:30-07:00",
      "updatedAt": "2023-03-22T09:01:49-07:00",
      "status": "active",
      "unsubscribed": false,
      "lastActivity": null,
      "externalCustomerId": "10001460",
      "subscriptionType": null,
      "channel": "Web",
      "subChannel": null,
      "subChannelDetail": null,
      "enrolledAt": "2023-03-20T13:41:30-07:00",
      "lastRewardDate": "2023-03-22T09:01:49-07:00",
      "lastRewardEventId": 365925986,
      "unsubscribedSms": true,
      "name": "Santiago Arellano",
      "balance": 75,
      "lifetimeBalance": 0,
      "imageUrl": null,
      "topTierName": null,
      "topTierExpirationDate": null,
      "authorizedPointsBalance": null,
      "pendingPointsBalance": 0,
      "balanceInDollars": null,
      "locale": null,
      "firstName": "Santiago",
      "middleName": null,
      "lastName": "Arellano",
      "city": null,
      "state": null,
      "postalCode": null,
      "homePhone": "(593) 984-3245",
      "country": null,
      "workPhone": null,
      "mobilePhone": null,
      "homeStore": null,
      "lastVisitDate": null,
      "birthdate": "2023-03-22T00:00:00-07:00",
      "addressLine1": null,
      "addressLine2": null,
      "customerCoupons": [{
        "code": "8817_20230321_799",
        "createdAt": "2023-03-21T06:30:34-07:00",
        "status": "redeemed",
        "redeemedAt": "2023-03-22T09:01:49-07:00",
        "expiresAt": "2023-03-23T23:59:59-07:00",
        "invalidatedAt": null,
        "usedAt": null,
        "redeemableId": 8817,
        "startAt": "2023-03-22T09:01:49-07:00",
        "startAtTimeZone": "Pacific Time (US & Canada)",
        "email": "santiago.arellano@verndale.com",
        "externalCustomerId": "10001460",
        "reward": {
          "name": "Enjoy a Barrel Bite on the house",
          "points": 0,
          "cost": "0.0",
          "posCode": "",
          "externalId": "welcome_05_23",
          "description": "Add a Barrel Bite to your order and it will be on the house. Enjoy! \r\n\r\nIf you have additional rewards, you'll be able to add them in your cart.",
          "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/9c8807dfcd10a9ba9335be41f37ddada.png",
          "posInstructions": "Welcome Reward",
          "redeemInstructions": "Welcome Reward",
          "rewardType": "base",
          "expirationDate": null,
          "rewardId": 8817,
          "displayName": "Welcome Reward"
        }
      }, {
        "code": "8817_20230321_7992",
        "createdAt": "2023-03-21T06:30:34-07:00",
        "status": "redeemed",
        "redeemedAt": "2023-03-22T09:01:49-07:00",
        "expiresAt": "2023-03-23T23:59:59-07:00",
        "invalidatedAt": null,
        "usedAt": null,
        "redeemableId": 8817,
        "startAt": "2023-03-22T09:01:49-07:00",
        "startAtTimeZone": "Pacific Time (US & Canada)",
        "email": "santiago.arellano@verndale.com",
        "externalCustomerId": "10001460",
        "reward": {
          "name": "Enjoy a Barrel Bite on the house",
          "points": 0,
          "cost": "0.0",
          "posCode": "",
          "externalId": "birthday_05_23",
          "description": "Add a Barrel Bite to your order and it will be on the house. Enjoy! \r\n\r\nIf you have additional rewards, you'll be able to add them in your cart.",
          "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/9c8807dfcd10a9ba9335be41f37ddada.png",
          "posInstructions": "Welcome Reward",
          "redeemInstructions": "Birthday",
          "rewardType": "bgirthday",
          "expirationDate": null,
          "rewardId": 8817,
          "displayName": "Welcome Reward"
        }
      }],
      "customerRewards": [{
        "id": 8817,
        "alertEnabled": false,
        "cost": "0.0",
        "createdAt": "2023-03-21T13:17:14-07:00",
        "description": "To redeem, add an item from this category to your order and select the Reward in your cart.\r\n\r\nDon't worry! If you have additional Rewards, you'll be able to add them to your cart.",
        "displayName": "Welcome Reward",
        "productSku": "",
        "dollarsToRedeem": "0.00",
        "expirationDate": "2023-03-22T08:52:04-07:00",
        "externalId": "welcome_05_23",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/eb1a70df58cb6dc4f5a873c548853bff.png",
        "instructions": "Welcome Reward",
        "name": "Enjoy Welcome Barrel Bites",
        "points": 0,
        "pointsToRedeem": 0,
        "posCode": "",
        "posInstructions": "Welcome Reward",
        "rewardType": "base",
        "status": true,
        "threshold": 0,
        "tiersRequired": false,
        "updatedAt": "2023-05-16T13:22:36-07:00",
        "tiers": [],
        "viewOptions": {
          "iframeHidden": false
        },
        "media": [{
          "default": true,
          "displayName": "Default",
          "key": "default",
          "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/eb1a70df58cb6dc4f5a873c548853bff.png"
        }],
        "currencyToRedeem": null,
        "offerMetadata": {
          "menuTag": ["barrel_bite"]
        }
      }, {
        "id": 8818,
        "alertEnabled": false,
        "cost": "0.0",
        "createdAt": "2023-03-22T08:41:07-07:00",
        "description": "To redeem, add an item from the dessert category to your order and select the Reward in your cart.\r\n\r\nDon't worry! If you have additional Rewards, you'll be able to add them to your cart.",
        "displayName": "Happy Birthday",
        "productSku": "",
        "dollarsToRedeem": "0.00",
        "expirationDate": null,
        "externalId": "birthday__05_23",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/ab1a1afb60403c5cd0fd9035ccb7c5f3.png",
        "instructions": "Birthday Reward",
        "name": "Have a sweet treat on us",
        "points": 0,
        "pointsToRedeem": 0,
        "posCode": "",
        "posInstructions": "Birthday Reward",
        "rewardType": "birthday",
        "status": true,
        "threshold": 0,
        "tiersRequired": false,
        "updatedAt": "2023-05-16T13:19:53-07:00",
        "tiers": [],
        "viewOptions": {
          "iframeHidden": false
        },
        "media": [{
          "default": true,
          "displayName": "Default",
          "key": "default",
          "url": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/ab1a1afb60403c5cd0fd9035ccb7c5f3.png"
        }],
        "currencyToRedeem": null,
        "offerMetadata": {}
      }, {
        "id": 8820,
        "name": "75 Peg Reward",
        "displayName": "75 Peg Reward",
        "points": 75,
        "createdAt": "2023-03-22T08:52:04-07:00",
        "updatedAt": "2023-03-22T09:07:51-07:00",
        "status": true,
        "cost": "0.0",
        "tiersRequired": false,
        "posCode": "",
        "externalId": "75_peg__05_23",
        "description": "To redeem, add an item from this category to your order and select the Reward in your cart.\r\n\r\nDon't worry! If you have additional Rewards, you'll be able to add them to your cart.",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/479fbea5196c21280886ae2e44eb67c8.png",
        "instructions": "75 Peg Reward",
        "posInstructions": "",
        "rewardType": "base",
        "expirationDate": null,
        "viewOptions": {},
        "tiers": [],
        "pointsToRedeem": 0,
        "currencyToRedeem": null,
        "offerMetadata": {
          "menuTag": ["barrel_bites"]
        }
      }, {
        "id": 8821,
        "name": "150 Peg Reward",
        "displayName": "150 Peg Reward",
        "points": 150,
        "createdAt": "2023-03-22T08:52:56-07:00",
        "updatedAt": "2023-03-22T09:07:52-07:00",
        "status": true,
        "cost": "0.0",
        "tiersRequired": false,
        "posCode": "",
        "externalId": "150_peg__05_23",
        "description": "To redeem, add an item from this category to your order and select the Reward in your cart.\r\n\r\nDon't worry! If you have additional Rewards, you'll be able to add them to your cart.",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/2a172b703258e82abaa2bbfa90399cf5.png",
        "instructions": "150 Peg Reward",
        "posInstructions": "150 Peg Reward",
        "rewardType": "base",
        "expirationDate": null,
        "viewOptions": {},
        "tiers": [],
        "pointsToRedeem": 75,
        "currencyToRedeem": null,
        "offerMetadata": {
          "menuTag": ["barrel_bites"]
        }
      }, {
        "id": 8822,
        "name": "225 Peg Reward",
        "displayName": "225 Peg Reward",
        "points": 225,
        "createdAt": "2023-03-22T08:53:44-07:00",
        "updatedAt": "2023-03-22T09:07:52-07:00",
        "status": true,
        "cost": "0.0",
        "tiersRequired": false,
        "posCode": "",
        "externalId": "225_peg__05_23",
        "description": "225 Peg Reward",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/c9051218388224560d9e9914e0532d87.png",
        "instructions": "225 Peg Reward",
        "posInstructions": "225 Peg Reward",
        "rewardType": "base",
        "expirationDate": null,
        "viewOptions": {},
        "tiers": [],
        "pointsToRedeem": 150,
        "currencyToRedeem": null
      }, {
        "id": 8823,
        "name": "250 Peg Reward",
        "points": 250,
        "createdAt": "2023-03-22T08:53:44-07:00",
        "updatedAt": "2023-03-22T09:07:52-07:00",
        "status": true,
        "cost": "0.0",
        "tiersRequired": false,
        "posCode": "",
        "externalId": "250_peg__05_23",
        "description": "250 Peg Reward",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/c9051218388224560d9e9914e0532d87.png",
        "instructions": "250 Peg Reward",
        "posInstructions": "250 Peg Reward",
        "rewardType": "base",
        "expirationDate": null,
        "viewOptions": {},
        "tiers": [],
        "pointsToRedeem": 250,
        "currencyToRedeem": null
      }, {
        "id": 8824,
        "name": "300 Peg Reward",
        "points": 300,
        "createdAt": "2023-03-22T08:53:44-07:00",
        "updatedAt": "2023-03-22T09:07:52-07:00",
        "status": true,
        "cost": "0.0",
        "tiersRequired": false,
        "posCode": "",
        "externalId": "300_peg__05_23",
        "description": "To redeem, add an item from this category to your order and select the Reward in your cart.\r\n\r\nDon't worry! If you have additional Rewards, you'll be able to add them to your cart.",
        "imageUrl": "https://d1iwtomgj4ct8d.cloudfront.net/merchant/c9051218388224560d9e9914e0532d87.png",
        "instructions": "300 Peg Reward",
        "posInstructions": "300 Peg Reward",
        "rewardType": "base",
        "expirationDate": null,
        "viewOptions": {},
        "tiers": [],
        "pointsToRedeem": 300,
        "currencyToRedeem": null,
        "offerMetadata": {
          "menuTag": ["barrel_bites"]
        }
      }]
    }
  }
};
var pegPointsModuleResponse = {
  loyalty: {
    customers: {
      points: 12
    }
  }
};
var getProductPointsResponse = [{
  "productChainId": 5239015,
  "points": 225,
  "posId": "CBRL-00402",
  "amount": 0.0,
  "type": "Entrée",
  "itemGroup": "Entrée",
  "rewardsId": ["instw_brlbite_05_23", "welcome_05_23"]
}, {
  "productChainId": 174558,
  "points": 225,
  "posId": "CBRL-00402",
  "amount": 0.0,
  "type": "Entrée",
  "itemGroup": "Entrée",
  "rewardsId": ["instw_drink_05_23", "birthday__05_23"]
}];
var rewardsRedemptionResponse = {
  /*  "redeemOptions": [
      {
        "totalDiscountAmount": 0.0,
        "totalPointsRedeemed": 0,
        "totalRetailDiscountAmount": 0.0,
        "bonusRewardsRedeemed": [],
        "cart": []
      }
    ]*/
  "redeemOptions": [{
    "totalDiscountAmount": 11.37,
    "totalPointsRedeemed": 250,
    "totalRetailDiscountAmount": 0.0,
    "validationText": "7b00b863711f8888aa6eae52d135b9e7",
    "bonusRewardsRedeemed": [{
      "bonusRewardId": "welcome_05_23"
    }],
    "cart": [{
      "productChainId": "486321",
      "posId": "RP00096",
      "productGroup": "Dessert",
      "points": 150,
      "pointsRedeemed": 150,
      "amount": 4.99,
      "cartLineItem": "2",
      "quantity": 1,
      "pointsDiscountAmount": 4.99,
      "bonusRewardDiscountAmount": 0.0,
      "redemptionType": "points"
    }, {
      "productChainId": "486077",
      "posId": "900000251",
      "productGroup": "Beverage",
      "points": 50,
      "pointsRedeemed": 100,
      "amount": 6.38,
      "cartLineItem": "1",
      "quantity": 2,
      "pointsDiscountAmount": 6.38,
      "bonusRewardDiscountAmount": 0.0,
      "redemptionType": "points"
    }]
  }]
};
var customRewardsRedemptionResponse = {
  /* "redeemOptions": [
     {
       "totalDiscountAmount": 0.0,
       "totalPointsRedeemed": 0,
       "totalRetailDiscountAmount": 0.0,
       "bonusRewardsRedeemed": [],
       "cart": []
     }
   ]*/
  "redeemOptions": [{
    "totalDiscountAmount": 3.19,
    "totalPointsRedeemed": 75,
    "totalRetailDiscountAmount": 0.0,
    "validationText": "7b00b863711f8888aa6eae52d135b9e7",
    "bonusRewardsRedeemed": [],
    "cart": [{
      "productChainId": "486077",
      "posId": "900000251",
      "productGroup": "Beverage",
      "points": 50,
      "pointsRedeemed": 50,
      "amount": 3.19,
      "cartLineItem": "1",
      "quantity": 1,
      "pointsDiscountAmount": 3.19,
      "redemptionType": "points"
    }]
  }]
};
var getOrderPegPointsResponse = {
  "loyalty": {
    "customers": {
      "events": [{
        "id": 385258043,
        "eventId": "10200203110000086",
        "customerId": 81302738,
        "email": "santiago.arellano@verndale.com",
        "eventType": "purchase",
        "status": 2,
        "detail": null,
        "createdAt": "2024-01-31T10:03:46-08:00",
        "updatedAt": "2024-01-31T10:03:46-08:00",
        "value": "0.0",
        "points": 0,
        "externalCustomerId": "10001460",
        "channel": "web",
        "tierId": null,
        "displayDetail": "Purchase",
        "rewardValue": null,
        "eventAttributes": {
          "deliveryType": "Curbside",
          "onlineOrderNumber": "23208352528842752",
          "tipsAmount": "0.0",
          "employeeSale": null,
          "storeName": "CB1020",
          "taxAmount": "0.0",
          "redeemedProductId": null,
          "discountAmount": null,
          "transactionTotalAmount": "0.0",
          "posReceiptId": "10200203110000086",
          "shippingFee": null,
          "otherDiscountAmount": null
        },
        "products": [{
          "productId": "900000257",
          "price": "0.0",
          "quantity": 1,
          "categories": null,
          "brands": null,
          "tags": ["Restaurant"],
          "internalProductId": null,
          "customAttributes": {}
        }],
        "imageUrl": null,
        "hidden": false,
        "brand": null,
        "subChannel": "cb102002",
        "subChannelDetail": "100100",
        "originatedAt": "2024-01-31T00:00:00-08:00"
      }, {
        "id": 385258042,
        "eventId": "10200203110000084",
        "customerId": 81302738,
        "email": "santiago.arellano@verndale.com",
        "eventType": "purchase",
        "status": 2,
        "detail": null,
        "createdAt": "2024-01-31T10:02:58-08:00",
        "updatedAt": "2024-01-31T10:02:58-08:00",
        "value": "13.16",
        "points": 13,
        "externalCustomerId": "10001460",
        "channel": "web",
        "tierId": null,
        "displayDetail": "Purchase",
        "rewardValue": null,
        "eventAttributes": {
          "deliveryType": "Curbside",
          "onlineOrderNumber": "23208312263737344",
          "tipsAmount": "0.0",
          "employeeSale": null,
          "storeName": "CB1020",
          "taxAmount": "1.28",
          "redeemedProductId": null,
          "discountAmount": null,
          "transactionTotalAmount": "14.44",
          "posReceiptId": "10200203110000084",
          "shippingFee": null,
          "otherDiscountAmount": null
        },
        "products": [{
          "productId": "900000257",
          "price": "52.64",
          "quantity": 4,
          "categories": null,
          "brands": null,
          "tags": ["Restaurant"],
          "internalProductId": null,
          "customAttributes": {}
        }],
        "imageUrl": null,
        "hidden": false,
        "brand": null,
        "subChannel": "cb102002",
        "subChannelDetail": "100100",
        "originatedAt": "2024-01-31T00:00:00-08:00"
      }]
    }
  }
};
export { pegRewardsResponse, bonusRewardsResponse, pegPointsModuleResponse, getProductPointsResponse, rewardsRedemptionResponse, customRewardsRedemptionResponse, getOrderPegPointsResponse };